import { API_URL_NEWS } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditNews from "types/News/createEditNews";

const updateNews = (uuid: string, editedItem: TCreateEditNews) =>
  apiInstance({
    url: API_URL_NEWS + uuid,
    method: "put",
    data: editedItem,
  });

export default updateNews;
